
import { ChevronLeftIcon } from "vue-feather-icons";
export default {
  components: {
    ChevronLeftIcon,
  },
};
